import InitApi from "api/InitApi";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import toast from "react-hot-toast";
import ServerErrors from "components/SeverErrors";
// import ServerErrors from "components/ServerErrors";

const useUpdatePhysicalBook = (book) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const update = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");
		const body = deleteEmptyObjects(obj);
		const formData = new FormData();
		Object.keys(body).forEach((key) => {
			formData.append(key, body[key]);
		});
		const response = await instance.post(
			`/books/physical/${book}?_method=PATCH`,
			formData
		);
		await queryClient.invalidateQueries("books");
		await queryClient.invalidateQueries("myUploadedBooks");
		return response?.data;
	};

	return useMutation(update, {
		onSuccess: async () => {
			toast.success("Book updated successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useUpdatePhysicalBook;
